import { IComponentOptions, IController } from 'angular';
import { ModalService } from '../modals/gmc-modal/gmc-modal.service';
import { IAttachementUploadModalData } from '../modals/attachment-uploader-modal/attachment-uploader-modal.component';
import { $Event } from '../../helpers';
import { Attachment } from './attachment';
import { IAttachmentUploadResult } from './attachment-upload-result.interface';
import './attachment-upload-btn.component.scss';
import { isObject } from 'lodash-es';

export class AttachmentUploadBtnCtrl implements IController {
  static $inject = [
    'ModalService'
  ];
  onUploaded: ( $event: $Event ) => void;
  accept = 'image/png,image/jpg,image/jpeg,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  maxSize = '20MB';
  pattern = '.png,.jpg,.jpeg,.pdf,.docx,.doc';
  _tooltip: string = 'Upload file(s)';
  multiple = true;

  constructor( private modalService: ModalService ) {
  }

  $onInit() {
  }

  set tooltip( text: string ) {
    this._tooltip = text;
  }

  get tooltip(): string {
    return `<div>${this._tooltip}</div>
            <div>${this.pattern}</div>
            <div>max-size: <span>${this.maxSize}</span></div>`;
  }

  uploadFiles( files: File[], invalidFiles: File[] ) {
    if ( files.length > 0 ) {
      const data: IAttachementUploadModalData = {
        files,
        invalidFiles,
        uploadUrl: `/user/saveFile/profile`
      };
      this.modalService.showModal({
        component: 'attachmentUploadModal',
        backdrop: false,
        extraClasses: 'modal-lg modal-dialog-centered-1',
        data
      }).then(( modal ) => modal.close)
        .then(( uploadResult ) => {
          if ( isObject(uploadResult) ) {
            const attachmentUploadResult: IAttachmentUploadResult = {
              errorFiles: uploadResult.errorFiles,
              successFiles: uploadResult.successFiles,
              attachments: uploadResult.successFiles.map(( item ) => new Attachment(item.result))
            };
            this.onUploaded(new $Event({ result: attachmentUploadResult }));
          }
        });
    }
  }

}

export const AttachmentUploadBtnComponent: IComponentOptions = {
  controller: AttachmentUploadBtnCtrl,
  template: require('./attachment-upload-btn.component.html'),
  bindings: {
    onUploaded: '&',
    tooltip: '@?',
    accept: '@?',
    multiple: '<?',
    pattern: '<?',
    maxSize: '<?'
  }
};



// WEBPACK FOOTER //
// ./app/components/attachment-upload-btn/attachment-upload-btn.component.ts